import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrendingUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.667 5.83594L11.7952 10.7839C11.7076 10.8728 11.6634 10.9172 11.6243 10.9523C10.9915 11.5187 10.0342 11.5187 9.40138 10.9523C9.36221 10.9172 9.31803 10.8728 9.23048 10.7838C9.14293 10.6949 9.09915 10.6505 9.05998 10.6154C8.42718 10.049 7.46989 10.049 6.83709 10.6154C6.79791 10.6505 6.75413 10.6949 6.66659 10.7839L3.33325 14.1693M16.667 5.83594L16.6666 10.8359M16.667 5.83594H11.6666",
		stroke: "#0C4D31",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTrendingUp;
